import axiosConfig from '../utils/axiosConfigInstance';

export const getContent = async params => {
	const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/trc/content`, { params });
	return response.data;
};

export const getContentById = async id => {
	const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/trc/content/${id}`);
	return response.data;
};
export const requestAccess = async formData => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/trc/user/request`, formData);
	return response.data;
};
export const responseAccess = async ({ userId, status }) => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/admin/trc/users/response`, {
		userId,
		status
	});
	return response.data;
};
export const fetchContent = async (query = {}) => {
  const url = `${import.meta.env.VITE_APP_API_URL}/trc/content`;
  const response = await axiosConfig.get(url, {
    params: query,   
  });

  return response.data;
};

export const getRelated = async id => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/trc/content/related`, {
		contentId: id
	});
	return response.data;
};

export const getStatus = async email => {
	const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/trc/user/status/${email}`);
	return response?.data;
};

export const searchContent = async query => {
	const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/trc/content?search=${query}`);
	return response.data;
}



export const trcApis = {
	getContent,
	getContentById,
	requestAccess,
	responseAccess,
	fetchContent,
	getRelated,
	getStatus,
	searchContent
};
